<template>
  <div>
    <div class="toolbar align-items-center">
      <div class="pending-pill">
        <b-icon-hourglass-split class="mr-2"></b-icon-hourglass-split>
        Total pending <strong>{{totalPending.toLocaleString('en') || 0}} kr</strong>
      </div>
      <div class="toolbar-field" style="max-width: 360px; margin-left: auto">
        <b-form-input
        id="filter"
        v-model="filter"
        type="text"
        placeholder="Filter clients">
        </b-form-input>
      </div>
      <router-link to="/invoices/new-company" class="btn btn-primary">
        <b-icon-plus class="mr-1"></b-icon-plus>New Client
      </router-link>
    </div>
    <div class="row mx-0">
      <div class="w-100">
        <table class="table">
          <thead>
          <tr>
            <th scope="col">Org. Number</th>
            <th scope="col">Name</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Email</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Phone</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Pending</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, i) in filteredList" v-bind:key="i" @click="goToClient(row._id)" class="pointer" :class="row.pending ? 'bg-warning text-dark' : ''">
            <th scope="row">{{!row.ttexId ? 'NOT IN TTEX' : row.oNumber || 'Private'}}</th>
            <td>{{row.name || "No name"}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.email || '/'}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.phone || '/'}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.pending ? row.pending.reduce((total, item) => total + (item.qtt * item.price), 0).toLocaleString('en') : 0}} kr</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import fixed from '../../fixed';

const API_URL = `${fixed.API_URL}/admin`;
export default {
  data: () => ({
    clients: [],
    filter: '',
    totalPending: 0,
  }),
  async mounted() {
    try {
      const { data } = await axios.get(`${API_URL}/clients`, { withCredentials: true });
      this.clients = data;
      // Calculate total pending
      data.forEach((row) => {
        if (row.pending && row.pending.length) {
          row.pending.forEach((item) => {
            this.totalPending += (item.price * item.qtt);
          });
        }
      });
    } catch (err) {
      this.$toast.error('can\'t get registered clients');
    }
  },
  computed: {
    filteredList() {
      return this.clients.filter((row) => row.name.toLowerCase().match(this.filter.toLowerCase())
        || row.email?.match(this.filter))
        .sort((a, b) => (b.pending && b.pending.length) || 0 - (a.pending && a.pending.length) || 0);
    },
  },
  methods: {
    goToClient(id) {
      this.$router.push({ name: 'client', params: { id } });
    },
  },
};
</script>

<style>
.pending-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.85rem;
  border-radius: var(--radius-sm);
  background: rgba(255, 197, 61, 0.14);
  border: 1px solid rgba(255, 197, 61, 0.35);
  color: #ffd97a;
  font-size: 0.875rem;
}

</style>
